import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

// GET /api/Deposit
export function* getDeposits(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        APIS.DEPOSITS.GET,
        action.payload,
        true
    );
}

// POST /api/Deposit
export function* addDeposit(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.DEPOSITS.ADD,
        action.payload,
        true
    );
}

// PUT /api/Deposit/{id}
export function* updateDeposit(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.PUT,
        APIS.DEPOSITS.UPDATE,
        action.payload,
        true
    );
}

// DELETE /api/Deposit/{id}
export function* deleteDeposit(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.DELETE,
        APIS.DEPOSITS.DELETE + action.payload.id,
        null,
        true
    );
}
